import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/seo/SEOHead";
import Brand from "@/components/ui/brand";
import { useTranslation } from "react-i18next";

const Datenschutz = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title={t("datenschutz.seoTitle")}
        description={t("datenschutz.seoDesc")}
        canonical="/datenschutz"
        noindex
      />
      <Header />

      <main id="main-content" className="flex-1 pt-28 pb-20 section-padding">
        <div className="max-w-3xl mx-auto space-y-12">
          <h1 className="text-headline">{t("datenschutz.title")}</h1>

          {/* 1. Verantwortlicher */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s1Title")}</h2>
            <p className="text-body">
              {t("datenschutz.s1Intro")}
            </p>
            <p className="text-body">
              <Brand /><br />
              Alexander Wolfshohl<br />
              Mittelpilghausen 20<br />
              42657 Solingen<br />
              {t("common.phone")}: 0212 24355800<br />
              {t("common.email")}: <a href="mailto:kontakt@craftfindus.de" className="text-accent hover:underline">kontakt@craftfindus.de</a>
            </p>
          </section>

          {/* 2. Allgemeines */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s2Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s2Text")}
            </p>
          </section>

          {/* 3. Rechtsgrundlagen */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s3Title")}</h2>
            <ul className="space-y-2 text-caption leading-relaxed list-disc pl-5">
              <li><strong>{t("datenschutz.s3a")}</strong></li>
              <li><strong>{t("datenschutz.s3b")}</strong></li>
              <li><strong>{t("datenschutz.s3c")}</strong></li>
              <li><strong>{t("datenschutz.s3f")}</strong></li>
            </ul>
          </section>

          {/* 4. Bereitstellung der Plattform */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s4Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s4Text1")}
            </p>
            <ul className="space-y-1 text-caption leading-relaxed list-disc pl-5">
              <li>{t("datenschutz.s4Li1")}</li>
              <li>{t("datenschutz.s4Li2")}</li>
              <li>{t("datenschutz.s4Li3")}</li>
              <li>{t("datenschutz.s4Li4")}</li>
              <li>{t("datenschutz.s4Li5")}</li>
            </ul>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s4Text2")}
            </p>
          </section>

          {/* 5. Registrierung & Nutzerkonto */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s5Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s5Text1")}
            </p>
            <ul className="space-y-1 text-caption leading-relaxed list-disc pl-5">
              <li>{t("datenschutz.s5Li1")}</li>
              <li>{t("datenschutz.s5Li2")}</li>
              <li>{t("datenschutz.s5Li3")}</li>
              <li>{t("datenschutz.s5Li4")}</li>
              <li>{t("datenschutz.s5Li5")}</li>
            </ul>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s5Text2")}
            </p>
          </section>

          {/* 6. IT-Anfragen */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s6Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s6Text1", { brand: "CRAFTFINDUS" })}
            </p>
            <ul className="space-y-1 text-caption leading-relaxed list-disc pl-5">
              <li>{t("datenschutz.s6Li1")}</li>
              <li>{t("datenschutz.s6Li2")}</li>
              <li>{t("datenschutz.s6Li3")}</li>
              <li>{t("datenschutz.s6Li4")}</li>
              <li>{t("datenschutz.s6Li5")}</li>
            </ul>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s6Text2")}
            </p>
          </section>

          {/* 7. Matching & Datenweitergabe */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s7Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s7Text1")}
            </p>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s7Text2")}
            </p>
          </section>

          {/* 8. Zahlungsdaten */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s8Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s8Text")}
            </p>
          </section>

          {/* 9. Hosting */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s9Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s9Text")}
            </p>
          </section>

          {/* 10. Cookies */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s10Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s10Text1")}
            </p>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s10Text2")}
            </p>
            <ul className="space-y-2 text-caption leading-relaxed list-disc pl-5">
              <li>
                <strong>{t("datenschutz.s10Necessary")}</strong>
              </li>
              <li>
                <strong>{t("datenschutz.s10Analytics")}</strong>
              </li>
              <li>
                <strong>{t("datenschutz.s10Marketing")}</strong>
              </li>
            </ul>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s10Text3")}
            </p>
          </section>

          {/* 11. Google Analytics */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s11Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s11Text1")}
            </p>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s11Text2")}
            </p>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s11Text3")}
            </p>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s11Text4")}{" "}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent hover:underline"
              >
                https://policies.google.com/privacy
              </a>
            </p>
          </section>

          {/* 12. SSL/TLS */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s12Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s12Text")}
            </p>
          </section>

          {/* 13. Rechte der Betroffenen */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s13Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s13Intro")}
            </p>
            <ul className="space-y-2 text-caption leading-relaxed list-disc pl-5">
              <li><strong>{t("datenschutz.s13Art15")}</strong></li>
              <li><strong>{t("datenschutz.s13Art16")}</strong></li>
              <li><strong>{t("datenschutz.s13Art17")}</strong></li>
              <li><strong>{t("datenschutz.s13Art18")}</strong></li>
              <li><strong>{t("datenschutz.s13Art20")}</strong></li>
              <li><strong>{t("datenschutz.s13Art21")}</strong></li>
              <li><strong>{t("datenschutz.s13Art7")}</strong></li>
              <li><strong>{t("datenschutz.s13Art77")}</strong></li>
            </ul>
          </section>

          {/* 14. Datenlöschung & Speicherdauer */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s14Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s14Text")}
            </p>
          </section>

          {/* 15. Änderungen */}
          <section className="space-y-3">
            <h2 className="text-subheadline">{t("datenschutz.s15Title")}</h2>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s15Text1")}
            </p>
            <p className="text-caption leading-relaxed">
              {t("datenschutz.s15Text2")}
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Datenschutz;